// generated at: http://text-crop.eightshapes.com/?typeface-selection=google-font&typeface=DM Sans&weight-and-style=300&size=16&line-height=1.5&top-crop=6&bottom-crop=7
function textCrop(_a) {
    var _b = _a.lineHeight, lineHeight = _b === void 0 ? 1.5 : _b, _c = _a.topAdjustment, topAdjustment = _c === void 0 ? "0px" : _c, _d = _a.bottomAdjustment, bottomAdjustment = _d === void 0 ? "0px" : _d, _e = _a.topCrop, topCrop = _e === void 0 ? 4 : _e, _f = _a.bottomCrop, bottomCrop = _f === void 0 ? 6 : _f, _g = _a.cropFontSize, cropFontSize = _g === void 0 ? 16 : _g, _h = _a.cropLineHeight, cropLineHeight = _h === void 0 ? 1.5 : _h;
    // Apply values to calculate em-based margins that work with any font size
    var dynamicTopCrop = Math.max(topCrop + (lineHeight - cropLineHeight) * (cropFontSize / 2), 0) /
        cropFontSize;
    var dynamicBottomCrop = Math.max(bottomCrop + (lineHeight - cropLineHeight) * (cropFontSize / 2), 0) / cropFontSize;
    return {
        lineHeight: lineHeight,
        "&::before, &::after": {
            content: "''",
            display: "block",
            height: 0,
            width: 0,
        },
        "&::before": {
            marginBottom: "calc(-".concat(dynamicTopCrop, "em + ").concat(topAdjustment, ")"),
        },
        "&::after": {
            marginTop: "calc(-".concat(dynamicBottomCrop, "em + ").concat(bottomAdjustment, ")"),
        },
    };
}

export { textCrop };
//# sourceMappingURL=textCrop.js.map
